import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { adaptUserData } from "./adapters.js";
import UserInfoOverview from "./UserInfoOverview.js";
const UserInfoOverviewContainer = ({ user, ...rest }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      name: getLabel("appointments.component.userInfoOverview.name"),
      child: getLabel("appointments.component.userInfoOverview.child"),
      email: getLabel("appointments.component.userInfoOverview.email"),
      phone: getLabel("appointments.component.userInfoOverview.phone")
    }),
    [getLabel]
  );
  const userData = React.useMemo(() => adaptUserData(user, labels), [user, labels]);
  return /* @__PURE__ */ React.createElement(UserInfoOverview, { ...rest, user: userData });
};
export {
  UserInfoOverviewContainer as default
};
//# sourceMappingURL=UserInfoOverviewContainer.js.map
